module.exports = __webpack_public_path__ + "static/img/service-use03.9924413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/service-use03.png
// module id = d8l0
// module chunks = 0